var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"two-column",attrs:{"data-external":"two-column"}},[_c('CMSRenderer',{staticClass:"two-column__1",attrs:{"content":_vm.column_1}}),_vm._v(" "),_c('CMSRenderer',{staticClass:"two-column__2",attrs:{"content":_vm.column_2}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }